import styles from './Divider.module.css';

/**
 * Thin separator used across the flight brief PDF sections.
 *
 * When a `subhead` slot is provided, the divider is forced horizontal and the
 * subhead is rendered underneath (e.g. the "MEETING INFORMATION" group).
 * @param {object} props
 * @param {'vertical' | 'horizontal'} [props.orientation] - Line direction.
 * @param {'solid' | 'dashed'} [props.variant] - Line style.
 * @param {React.ReactNode} [props.subhead] - Optional label rendered under the line.
 * @param {string} [props.subheadClassName] - Extra class names for the subhead label.
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function Divider({
  orientation = 'vertical',
  variant = 'solid',
  subhead = null,
  subheadClassName = '',
  className = '',
}) {
  if (subhead) {
    return (
      <div className={`${styles['subhead-group']} ${className}`}>
        <span className={`${styles.line} ${styles.horizontal} ${styles[variant]}`} />
        <span className={`${styles.subhead} ${subheadClassName}`}>{subhead}</span>
      </div>
    );
  }

  return (
    <span className={`${styles.line} ${styles[orientation]} ${styles[variant]} ${className}`} />
  );
}

export default Divider;
